import apiClient from '../../../services/apiClient';

export const getEmailTemplatePreview = (
  orgId: string,
  templateName: string,
  data: { [key: string]: string },
  emails = ['email@address.com']
) => apiClient.post('/v1/template/preview', { templateName, orgId, emails, data }).then(response => response.data);
